<script setup lang="ts">
import { useIntersectionObserver } from '@vueuse/core'
import { onUnmounted, ref } from 'vue'

const target = ref(null)
const targetIsVisible = ref(false)

const { stop } = useIntersectionObserver(target, ([{ isIntersecting }]) => {
  targetIsVisible.value = isIntersecting
  if (isIntersecting) {
    stop()
  }
})
onUnmounted(() => {
  stop()
})
</script>
<template>
  <div ref="target" class="image-lazy-loading h-full" :class="{ '[image-rendering:_auto]': targetIsVisible, '[image-rendering:_pixelated]': !targetIsVisible}">
    <transition
      enter-active-class="transition duration-300 ease-out"
      enter-from-class="transform opacity-0"
      enter-to-class="transform opacity-100"
      leave-active-class="transition duration-300 ease-in"
      leave-from-class="transform opacity-100"
      leave-to-class="transform opacity-0"
    >
      <slot v-if="targetIsVisible" />
    </transition>
  </div>
</template>